// import { getProfile, login, logout } from '../../services/api';

export function add_to_basket(item) {
  return async (dispatch) => {
    try {
      await dispatch(added_to_basket(item));
      return;
    } catch (e) {
      console.error(e);
      return;
    }
  };
}

export function remove_from_basket(item) {
  return async (dispatch) => {
    try {
      await dispatch(removed_from_basket(item));
      return;
    } catch (e) {
      console.error(e);
      return;
    }
  };
}

export function clear_basket() {
    return async (dispatch) => {
      try {
        await dispatch(cleared_basket());
        return;
      } catch (e) {
        console.error(e);
        return;
      }
    };
  }

function added_to_basket(item) {
  return { type: "ADDED_TO_BASKET", item };
}

function removed_from_basket(item) {
  return { type: "REMOVED_FROM_BASKET", item };
}

function cleared_basket() {
    return { type: "CLEARED_BASKET" };
  }
